import { Transition } from '@headlessui/react';
import PropTypes from 'prop-types';

function OnboardingFormStep({ children, step, description, show, title }) {
  return (
    <Transition
      show={show}
      appear
      as="div"
      className="flex flex-col gap-y-8 transition-opacity duration-1000 data-closed:opacity-0 data-enter:opacity-100 data-leave:opacity-0"
    >
      <div className="border-b border-b-rcprimary-400/50 pb-3">
        <div className="flex flex-col gap-x-4 sm:flex-row">
          <div className="shrink-0">
            <h2 className="font-bold text-3xl text-rcprimary-400">
              Step {step}
            </h2>
          </div>
          <div className="grow">
            <h3 className="font-medium text-rcprimary-400 text-xl">{title}</h3>
            <p className="text-base text-black/60">{description}</p>
          </div>
        </div>
      </div>
      {children}
    </Transition>
  );
}

OnboardingFormStep.propTypes = {
  children: PropTypes.node.isRequired,
  step: PropTypes.number.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default OnboardingFormStep;
